// @flow
import React, { PureComponent } from "react";
import classNames from "classnames";

type Props = {
  height: number,
  width: number,
  className: any
};

class Hat extends PureComponent<Props> {
  render() {
    const { height, width, className } = this.props;
    const classes = classNames("icone", className);

    return (
      <svg className={classes} height={height} width={width} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
        <title>Estudante</title>
        <desc>Representação de um capelo</desc>
        <g id="icon-hat-small">
          <path d="M14.77,3.65l-6-2.5a2.05,2.05,0,0,0-1.54,0l-6,2.5a2,2,0,0,0,0,3.7L2,7.67V10.8a3,3,0,0,0,1.89,2.79l3,1.2a3,3,0,0,0,2.22,0l3-1.2A3,3,0,0,0,14,10.8V7.67l.77-.32a2,2,0,0,0,0-3.7ZM12,10.8a1,1,0,0,1-.63.93l-3,1.2a1,1,0,0,1-.74,0l-3-1.2A1,1,0,0,1,4,10.8V8.5L7.23,9.85a2.05,2.05,0,0,0,1.54,0L12,8.5Zm.61-4.72h0L8,8,3.39,6.08h0L2,5.5,8,3l6,2.5Z" />
        </g>
      </svg>
    );
  }
}

export default Hat;
